var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useState } from "react";
import axios from "axios";
import { getLicenseApiUrl } from "@helpers";
export var useLicense = function (token) {
    var _a = useState({}), license = _a[0], setLicense = _a[1];
    var _b = useState([]), licenseLogs = _b[0], setLicenseLogs = _b[1];
    var _c = useState(false), loading = _c[0], setLoading = _c[1];
    var _d = useState(false), licenseLogsLoading = _d[0], setLicenseLogsLoading = _d[1];
    var wapiConfig = {
        headers: {
            'cache-control': 'no-cache',
            'wapi-token': token
        }
    };
    var updateLicense = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var license, created, expires, active, rest, _created, _expires, reworkedData, response, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setLoading(true);
                    license = data.license, created = data.created, expires = data.expires, active = data.active, rest = __rest(data, ["license", "created", "expires", "active"]);
                    _created = Math.floor(new Date(created).getTime() / 1000);
                    _expires = Math.floor(new Date(expires).getTime() / 1000);
                    reworkedData = __assign(__assign({}, rest), { active: active.toString(), created: _created, expires: _expires });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios.put(getLicenseApiUrl((_a = data.license) !== null && _a !== void 0 ? _a : ''), reworkedData, wapiConfig)];
                case 2:
                    response = _b.sent();
                    setLicense(response.data);
                    setLoading(false);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    console.error('Update license error', error_1);
                    setLoading(false);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var createLicense = function (data) {
        if (!process.env.LICENSE_URL) {
            console.error('You are not set LICENSE URL to env file.');
        }
        return new Promise(function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axios.post(process.env.LICENSE_URL, data, wapiConfig)];
                    case 2:
                        response = _a.sent();
                        setLicense(response.data);
                        resolve(response.data);
                        setLoading(false);
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        reject({
                            error: true,
                            message: 'Create license error'
                        });
                        console.error('Create license error', error_2);
                        setLoading(false);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); });
    };
    var getLicense = function (url) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, , 7]);
                    return [4 /*yield*/, axios.get(url, wapiConfig)];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, setLicense(response.data)];
                case 3:
                    _a.sent();
                    return [4 /*yield*/, setLoading(false)];
                case 4:
                    _a.sent();
                    return [3 /*break*/, 7];
                case 5:
                    error_3 = _a.sent();
                    console.error('Get license error ', error_3);
                    return [4 /*yield*/, setLoading(false)];
                case 6:
                    _a.sent();
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var getLicenseLogs = function (key) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLicenseLogsLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios.get(getLicenseApiUrl(key, true), wapiConfig)];
                case 2:
                    response = _a.sent();
                    setLicenseLogs(response.data.log_entries);
                    setLicenseLogsLoading(false);
                    return [3 /*break*/, 4];
                case 3:
                    error_4 = _a.sent();
                    console.error('Get license error ', error_4);
                    setLicenseLogsLoading(false);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return {
        license: license,
        licenseLogs: licenseLogs,
        loading: loading,
        licenseLogsLoading: licenseLogsLoading,
        createLicense: createLicense,
        updateLicense: updateLicense,
        getLicense: getLicense,
        getLicenseLogs: getLicenseLogs
    };
};
